module.exports = __webpack_public_path__ + "img/valtis-logo-white.36a7c968.png";